import type { Portfolio } from './Portfolio';

export class PortfolioResponse {
    public portfolioList?: Array<Portfolio>;

    public constructor(props: Pick<PortfolioResponse, 'portfolioList'>) {
        Object.assign(this, props);
    }
}
